// Utility functions for cookie handling
function setModalCookie(name, value, hours) {
  const d = new Date();
  d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getModalCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

document.addEventListener('DOMContentLoaded', () => {
   const modalSignupButton = document.querySelector('.modal-signup-button');
   const modalSignup = document.querySelector('.signup-modal');
   const signupCloser = document.querySelector('.signupCloser');
   const MODAL_COOKIE = 'kinfill_signup_modal';
   const MODAL_COOKIE_HOURS = 168; // 7 days * 24 hours

   // Helper to open modal
   function openModal() {
     if (modalSignup) modalSignup.classList.remove('hidden');
   }
   // Helper to close modal
   function closeModal() {
     if (modalSignup) modalSignup.classList.add('hidden');
     setModalCookie(MODAL_COOKIE, 'closed', MODAL_COOKIE_HOURS);
   }

   // Remove homepage-only restriction: show modal everywhere after delay if cookie is not set
   if (!getModalCookie(MODAL_COOKIE)) {
     setTimeout(() => {
       // Double check cookie (in case user interacted in the meantime)
       if (!getModalCookie(MODAL_COOKIE)) {
         openModal();
       }
     }, 12000); // 2 seconds for testing, change to 10000 for 10s
   }

   // Always attach close button event if present
   if (signupCloser && modalSignup) {
      signupCloser.addEventListener('click', (e) => {
         e.preventDefault();
         closeModal();
      });
   }

   // Only attach modalSignupButton event if present
   if (modalSignupButton && modalSignup) {
      modalSignupButton.addEventListener('click', (e) => {
         e.preventDefault();
         modalSignup.classList.toggle('hidden');
      });
   }

   // Listen for Klaviyo form submission (form is injected dynamically)
   // We'll use event delegation on the modal
   if (modalSignup) {
     modalSignup.addEventListener('submit', function(e) {
       if (e.target && e.target.classList.contains('klaviyo-form')) {
         setModalCookie(MODAL_COOKIE, 'submitted', MODAL_COOKIE_HOURS);
         closeModal();
       }
     }, true);
   }

   // Fallback: observe for injected Klaviyo form and listen for submit
   const klaviyoFormObserver = new MutationObserver(() => {
     const klaviyoForm = modalSignup && modalSignup.querySelector('form.klaviyo-form');
     if (klaviyoForm && !klaviyoForm.dataset.kinfillListener) {
       klaviyoForm.addEventListener('submit', function() {
         setModalCookie(MODAL_COOKIE, 'submitted', MODAL_COOKIE_HOURS);
         closeModal();
       });
       klaviyoForm.dataset.kinfillListener = 'true';
     }
   });
   if (modalSignup) {
     klaviyoFormObserver.observe(modalSignup, { childList: true, subtree: true });
   }

   // Listen for Klaviyo subscribe success event and close modal
   document.addEventListener('klaviyoForms', function(e) {
     if (e.detail && e.detail.type === 'success') {
       setModalCookie(MODAL_COOKIE, 'submitted', MODAL_COOKIE_HOURS);
       closeModal();
     }
   });
});